import lightGhost from './../../images/light-ghost.png';
import darkGhost from './../../images/dark-ghost.png';

export default function HomeGhosts() {
  return (
    <>
      {/* middle ghost */}
      <img
        src={lightGhost}
        alt="Friendly ghost"
        className="fixed bottom-[-1em] w-60 h-60 z-0 block dark:hidden"
      />
      <img
        src={darkGhost}
        alt="Friendly ghost"
        className="fixed bottom-[-1em] w-60 h-60 z-0 hidden dark:block"
      />

      <div className="hidden sm:inline">
        {/* left ghost */}
        <img
          src={lightGhost}
          alt="Friendly ghost"
          className="fixed bottom-60 left-[-5em] w-60 h-60 z-0 rotate-[50deg] block dark:hidden"
        />
        <img
          src={darkGhost}
          alt="Friendly ghost"
          className="fixed bottom-60 left-[-5em] w-60 h-60 z-0 rotate-[50deg] hidden dark:block"
        />
        {/* right ghost */}
        <img
          src={lightGhost}
          alt="Friendly ghost"
          className="fixed bottom-60 right-[-5em] w-60 h-60 z-0 rotate-[-50deg] block dark:hidden"
        />
        <img
          src={darkGhost}
          alt="Friendly ghost"
          className="fixed bottom-60 right-[-5em] w-60 h-60 z-0 rotate-[-50deg] hidden dark:block"
        />
      </div>
    </>
  );
}
